import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Card, Space, Typography } from 'antd';
import { DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import { removeResponseById } from '../Store/slices/gpt.slice';


const ResponseMessage = ({ response, timestamp, cardClass='' }) => {
    const dispatch = useDispatch();
    const [content, setContent] = useState('');
    console.log(response);
    useEffect(() => {
        setContent(<div dangerouslySetInnerHTML={{__html: response.data}}></div>);
    }, [response]); // Dependence on `response` to ensure effect runs only if `response` changes

    const handleRemoveClick = () => {
        dispatch(removeResponseById(response.id)); // Use UUID to remove response
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(response.data)
          .then(() => {
            console.log('Response copied to clipboard');
          })
          .catch((error) => {
            console.error('Failed to copy response: ', error);
          });
    };

    return (
        <Card
            className={cardClass}
            style={{borderRadius: '16px'}}
            bordered={false}
            title={
                <Space >
                    <Typography.Text style={{ marginRight: 'auto' }}>
                        {timestamp}
                    </Typography.Text>
                    <Button
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={handleRemoveClick}
                    />
                    <Button
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={handleCopyClick}
                    />
                </Space>
            }
        >
            <div style={{fontFamily:"var(--mono-font)"}}>
                {content}
            </div>
        </Card>
    );
};

export default ResponseMessage;
